import { HeadingBlock } from "./HeadingBlock";

export * from "./HeadingBlock";

export default HeadingBlock;
